import NewScriptPage from "./NewScriptPage"

export default NewScriptPage